module.exports = __webpack_public_path__ + "static/img/tiao.bf50511.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commission/tiao.png
// module id = 0JEL
// module chunks = 69